module.exports = __webpack_public_path__ + "img/team-2.90c40d0c.jpg";